<template>
  <div class="container container-fixed p-t-20">
    <div class=" no-padding p-t-20 p-b-20 bg-white">
      <div class="container">
        <h1>{{ $t('current_user.entities_profile') }}</h1>
        <h3 class="m-t-20">{{ $t('EditProfile.information_professional') }}</h3>

        <template v-if="isSingleEntity">
          <div class="row m-t-20">
            <label class="col-md-3 control-label">{{ $t('table.headers.entity') }}:</label>
            <div class="col-md-6">
              <div><b>{{ userEditing.entities[0].name }}</b></div>
              <div>{{ userEditing.user_entities[0].function }}</div>
            </div>
          </div>

          <div class="row m-t-20">
            <label class="col-md-3 control-label">{{ $t('models.user.services') }}:</label>
            <div class="col-md-6">
              <services-grouped-by-hubs :hubs="userEditing.hubs" :services="userEditing.services" />
            </div>
          </div>
        </template>

        <manager-entities-table
          v-if="!isSingleEntity && currentUser.user_entities"
          :managerEntities="currentUser.user_entities"
          :currentUser="currentUser"
          :isMyEntityPage="true"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import ManagerEntitiesTable from '@/components/users/ManagerEntitiesTable'
  import ServicesGroupedByHubs from '@/components/hubs/ServicesGroupedByHubs'

  export default {
    name: 'ManagerEntities',
    components: {
      ManagerEntitiesTable,
      ServicesGroupedByHubs
    },
    computed: {
      ...mapGetters({
        currentUser: 'auth/currentUser',
        isSingleEntity: 'auth/isSingleEntity'
      }),
      userEditing() {
        return Object.assign({}, this.currentUser)
      }
    },
    mounted() {
      if (this.currentUser) {
        this.$store.commit('users/SET_SIBLING_ENTITIES', this.currentUser.entities)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/entities/ManagerEntities.vue